/**
 * Zentrale Preiskonfiguration für den SkyVision Konfigurator
 * Tabellenbasierte Preisberechnung mit 100mm-Schritten
 */

// Grundkonfiguration für SkyVision FIXED
export const SKYVISION_FIXED_CONFIG = {
  baseDimensions: {
    width: 300,    // Mindestbreite in mm (300mm Bestellmaß = 330mm Rohbauöffnung)
    length: 300,   // Mindestlänge in mm (300mm Bestellmaß = 330mm Rohbauöffnung)
    height: 210    // Standard-Höhe in mm für 2-fach Verglasung
  },
  // Keine Preiskonfiguration mehr, da alles über die Formel läuft
  
  // Keine zusätzlichen Preisregeln mehr, da alles über die Formel läuft
  
  glassTypes: {
    double: {
      name: '2-fach Isolierverglasung',
      description: 'Sehr gute Wärmedämmung (Ug-Wert 1,1)',
      minHeight: 210
    },
    triple: {
      name: '3-fach Isolierverglasung', 
      description: 'Maximale Energieeffizienz (Ug-Wert 0,7)',
      minHeight: 240 // 15% Aufschlag wird in der Formel berechnet
    }
  }
};

// Neue Preistabelle für SkyVision FIXED (2-fach Verglasung)
// Breite (mm) als Schlüssel, Länge (mm) → Preis (€) als Werte
export const FIXED_PRICE_TABLE_2FACH = {
  300: { 300: 765, 400: 831, 500: 897, 600: 962, 700: 1028, 800: 1094, 900: 1160, 1000: 1225, 1100: 1291, 1200: 1357, 1300: 1422, 1400: 1506, 1500: 1572, 1600: 1639, 1700: 1706, 1800: 1773, 1900: 1839, 2000: 1906, 2100: 1973, 2200: 2040, 2300: 2107, 2400: 2173, 2500: 2240, 2600: 2307, 2700: 2374, 2800: 2440, 2900: 2575, 3000: 2722 },
  400: { 300: 831, 400: 958, 500: 966, 600: 1031, 700: 1101, 800: 1156, 900: 1230, 1000: 1303, 1100: 1371, 1200: 1438, 1300: 1506, 1400: 1594, 1500: 1662, 1600: 1731, 1700: 1800, 1800: 1868, 1900: 1937, 2000: 2006, 2100: 2074, 2200: 2143, 2300: 2212, 2400: 2281, 2500: 2349, 2600: 2418, 2700: 2487, 2800: 2555, 2900: 2708, 3000: 2846 },
  500: { 300: 897, 400: 966, 500: 1035, 600: 1104, 700: 1173, 800: 1243, 900: 1312, 1000: 1381, 1100: 1450, 1200: 1519, 1300: 1589, 1400: 1682, 1500: 1752, 1600: 1823, 1700: 1893, 1800: 1964, 1900: 2035, 2000: 2105, 2100: 2176, 2200: 2247, 2300: 2317, 2400: 2388, 2500: 2458, 2600: 2529, 2700: 2600, 2800: 2670, 2900: 2833, 3000: 3010 },
  600: { 300: 962, 400: 1031, 500: 1104, 600: 1175, 700: 1246, 800: 1317, 900: 1388, 1000: 1459, 1100: 1530, 1200: 1601, 1300: 1672, 1400: 1769, 1500: 1842, 1600: 1915, 1700: 1987, 1800: 2060, 1900: 2132, 2000: 2205, 2100: 2277, 2200: 2350, 2300: 2422, 2400: 2495, 2500: 2568, 2600: 2640, 2700: 2713, 2800: 2785, 2900: 2962, 3000: 3144 },
  700: { 300: 1028, 400: 1101, 500: 1173, 600: 1246, 700: 1319, 800: 1391, 900: 1464, 1000: 1537, 1100: 1610, 1200: 1682, 1300: 1755, 1400: 1857, 1500: 1932, 1600: 2006, 1700: 2081, 1800: 2155, 1900: 2230, 2000: 2304, 2100: 2379, 2200: 2453, 2300: 2528, 2400: 2602, 2500: 2677, 2600: 2751, 2700: 2826, 2800: 2900, 2900: 3092, 3000: 3419 },
  800: { 300: 1094, 400: 1156, 500: 1243, 600: 1317, 700: 1391, 800: 1466, 900: 1540, 1000: 1615, 1100: 1716, 1200: 1791, 1300: 1865, 1400: 1945, 1500: 2022, 1600: 2098, 1700: 2175, 1800: 2251, 1900: 2327, 2000: 2404, 2100: 2480, 2200: 2557, 2300: 2633, 2400: 2709, 2500: 2786, 2600: 2862, 2700: 2939, 2800: 3015, 2900: 3221, 3000: 3579 },
  900: { 300: 1160, 400: 1230, 500: 1312, 600: 1388, 700: 1464, 800: 1540, 900: 1616, 1000: 1800, 1100: 1881, 1200: 1961, 1300: 2041, 1400: 2121, 1500: 2202, 1600: 2282, 1700: 2362, 1800: 2442, 1900: 2523, 2000: 2580, 2100: 2683, 2200: 2676, 2300: 2759, 2400: 2762, 2500: 2855, 2600: 2848, 2700: 2941, 2800: 3139, 2900: 3360, 3000: 4444 },
  1000: { 300: 1225, 400: 1303, 500: 1381, 600: 1459, 700: 1537, 800: 1615, 900: 1800, 1000: 1881, 1100: 1961, 1200: 2041, 1300: 2121, 1400: 2201, 1500: 2282, 1600: 2362, 1700: 2442, 1800: 2523, 1900: 2580, 2000: 2683, 2100: 2763, 2200: 2676, 2300: 2759, 2400: 2762, 2500: 2855, 2600: 2848, 2700: 2941, 2800: 3139, 2900: 3360, 3000: 4444 },
  1100: { 300: 1291, 400: 1371, 500: 1450, 600: 1530, 700: 1610, 800: 1716, 900: 1881, 1000: 1961, 1100: 2045, 1200: 2129, 1300: 2213, 1400: 2297, 1500: 2381, 1600: 2466, 1700: 2550, 1800: 2634, 1900: 2718, 2000: 3135, 2100: 3233, 2200: 3355, 2300: 3558, 2400: 3662, 2500: 3766, 2600: 3869, 2700: 3973, 2800: 4077, 2900: 4723, 3000: 4844 },
  1200: { 300: 1357, 400: 1438, 500: 1519, 600: 1601, 700: 1682, 800: 1791, 900: 1961, 1000: 2041, 1100: 2129, 1200: 2213, 1300: 2299, 1400: 2385, 1500: 2471, 1600: 2557, 1700: 2641, 1800: 2729, 1900: 2815, 2000: 3257, 2100: 3359, 2200: 3495, 2300: 3698, 2400: 3802, 2500: 3912, 2600: 4019, 2700: 4126, 2800: 4232, 2900: 4218, 3000: 5044 },
  1300: { 300: 1422, 400: 1506, 500: 1589, 600: 1672, 700: 1755, 800: 1865, 900: 2041, 1000: 2121, 1100: 2213, 1200: 2299, 1300: 2385, 1400: 2473, 1500: 2561, 1600: 2651, 1700: 2741, 1800: 2831, 1900: 2921, 2000: 3011, 2100: 3502, 2200: 3609, 2300: 3698, 2400: 4005, 2500: 4176, 2600: 4297, 2700: 4418, 2800: 4539, 2900: 4539, 3000: 0 },
  1400: { 300: 1506, 400: 1594, 500: 1682, 600: 1769, 700: 1857, 800: 1945, 900: 2121, 1000: 2201, 1100: 2297, 1200: 2385, 1300: 2473, 1400: 2561, 1500: 2651, 1600: 2741, 1700: 2831, 1800: 2921, 1900: 3011, 2000: 3379, 2100: 3484, 2200: 3508, 2300: 4005, 2400: 4176, 2500: 4418, 2600: 4539, 2700: 0, 2800: 0, 2900: 0, 3000: 0 },
  1500: { 300: 1572, 400: 1662, 500: 1752, 600: 1842, 700: 1932, 800: 2022, 900: 2202, 1000: 2282, 1100: 2381, 1200: 2471, 1300: 2561, 1400: 2651, 1500: 2741, 1600: 2831, 1700: 2921, 1800: 3011, 1900: 3502, 2000: 3609, 2100: 3698, 2200: 4005, 2300: 4176, 2400: 4297, 2500: 4418, 2600: 4539, 2700: 0, 2800: 0, 2900: 0, 3000: 0 },
  1600: { 300: 1639, 400: 1731, 500: 1823, 600: 1915, 700: 2006, 800: 2098, 900: 2282, 1000: 2362, 1100: 2466, 1200: 2557, 1300: 2651, 1400: 2741, 1500: 2831, 1600: 2921, 1700: 3011, 1800: 3379, 1900: 3484, 2000: 3609, 2100: 3698, 2200: 4005, 2300: 4176, 2400: 4418, 2500: 4539, 2600: 0, 2700: 0, 2800: 0, 2900: 0, 3000: 0 }
};

// Mehrpreise für 3-fach Verglasung (ecoline)
export const FIXED_PRICE_SURCHARGE_3FACH = {
  300: { 300: 38, 400: 43, 500: 49, 600: 55, 700: 60, 800: 65, 900: 70, 1000: 77, 1100: 82, 1200: 88, 1300: 106, 1400: 117, 1500: 131, 1600: 138, 1700: 146, 1800: 152, 1900: 158, 2000: 165, 2100: 172, 2200: 178, 2300: 185, 2400: 192, 2500: 199, 2600: 204, 2700: 212, 2800: 220, 2900: 310, 3000: 310 },
  400: { 300: 43, 400: 49, 500: 56, 600: 63, 700: 69, 800: 76, 900: 82, 1000: 89, 1100: 95, 1200: 102, 1300: 125, 1400: 137, 1500: 152, 1600: 162, 1700: 170, 1800: 179, 1900: 188, 2000: 196, 2100: 205, 2200: 214, 2300: 222, 2400: 231, 2500: 240, 2600: 249, 2700: 257, 2800: 265, 2900: 275, 3000: 311 },
  500: { 300: 49, 400: 56, 500: 63, 600: 71, 700: 78, 800: 84, 900: 92, 1000: 99, 1100: 107, 1200: 114, 1300: 137, 1400: 152, 1500: 162, 1600: 170, 1700: 179, 1800: 188, 1900: 196, 2000: 205, 2100: 214, 2200: 222, 2300: 231, 2400: 240, 2500: 249, 2600: 257, 2700: 265, 2800: 275, 2900: 311, 3000: 407 },
  600: { 300: 55, 400: 63, 500: 71, 600: 79, 700: 86, 800: 94, 900: 101, 1000: 110, 1100: 118, 1200: 126, 1300: 153, 1400: 171, 1500: 182, 1600: 189, 1700: 200, 1800: 209, 1900: 219, 2000: 228, 2100: 239, 2200: 248, 2300: 258, 2400: 267, 2500: 277, 2600: 287, 2700: 296, 2800: 306, 2900: 320, 3000: 456 },
  700: { 300: 60, 400: 69, 500: 78, 600: 86, 700: 95, 800: 104, 900: 113, 1000: 121, 1100: 130, 1200: 139, 1300: 169, 1400: 189, 1500: 199, 1600: 210, 1700: 220, 1800: 231, 1900: 241, 2000: 252, 2100: 263, 2200: 274, 2300: 284, 2400: 295, 2500: 305, 2600: 316, 2700: 326, 2800: 338, 2900: 408, 3000: 477 },
  800: { 300: 65, 400: 76, 500: 84, 600: 94, 700: 104, 800: 113, 900: 123, 1000: 132, 1100: 142, 1200: 152, 1300: 194, 1400: 224, 1500: 236, 1600: 249, 1700: 262, 1800: 274, 1900: 287, 2000: 300, 2100: 312, 2200: 325, 2300: 338, 2400: 350, 2500: 363, 2600: 376, 2700: 388, 2800: 400, 2900: 485, 3000: 584 },
  900: { 300: 70, 400: 82, 500: 92, 600: 101, 700: 113, 800: 123, 900: 134, 1000: 173, 1100: 186, 1200: 198, 1300: 211, 1400: 224, 1500: 236, 1600: 249, 1700: 262, 1800: 274, 1900: 287, 2000: 300, 2100: 312, 2200: 325, 2300: 338, 2400: 350, 2500: 363, 2600: 376, 2700: 388, 2800: 400, 2900: 485, 3000: 584 },
  1000: { 300: 77, 400: 89, 500: 99, 600: 110, 700: 121, 800: 132, 900: 173, 1000: 186, 1100: 198, 1200: 211, 1300: 224, 1400: 236, 1500: 249, 1600: 262, 1700: 274, 1800: 287, 1900: 300, 2000: 312, 2100: 325, 2200: 338, 2300: 350, 2400: 363, 2500: 376, 2600: 388, 2700: 400, 2800: 485, 2900: 584, 3000: 667 },
  1100: { 300: 82, 400: 95, 500: 107, 600: 118, 700: 130, 800: 142, 900: 186, 1000: 198, 1100: 211, 1200: 224, 1300: 236, 1400: 249, 1500: 262, 1600: 274, 1700: 287, 1800: 300, 1900: 312, 2000: 325, 2100: 338, 2200: 350, 2300: 363, 2400: 376, 2500: 388, 2600: 400, 2700: 485, 2800: 584, 2900: 667, 3000: 710 },
  1200: { 300: 88, 400: 102, 500: 114, 600: 126, 700: 139, 800: 152, 900: 198, 1000: 211, 1100: 224, 1200: 236, 1300: 249, 1400: 262, 1500: 274, 1600: 287, 1700: 300, 1800: 312, 1900: 325, 2000: 338, 2100: 350, 2200: 363, 2300: 376, 2400: 388, 2500: 400, 2600: 485, 2700: 584, 2800: 667, 2900: 710, 3000: 0 },
  1300: { 300: 106, 400: 125, 500: 137, 600: 153, 700: 169, 800: 194, 900: 211, 1000: 224, 1100: 236, 1200: 249, 1300: 262, 1400: 274, 1500: 287, 1600: 300, 1700: 312, 1800: 325, 1900: 338, 2000: 350, 2100: 363, 2200: 376, 2300: 388, 2400: 400, 2500: 485, 2600: 584, 2700: 667, 2800: 710, 2900: 0, 3000: 0 },
  1400: { 300: 117, 400: 137, 500: 152, 600: 171, 700: 189, 800: 224, 900: 224, 1000: 236, 1100: 249, 1200: 262, 1300: 274, 1400: 287, 1500: 300, 1600: 312, 1700: 325, 1800: 338, 1900: 350, 2000: 363, 2100: 376, 2200: 388, 2300: 400, 2400: 485, 2500: 584, 2600: 667, 2700: 710, 2800: 0, 2900: 0, 3000: 0 },
  1500: { 300: 131, 400: 152, 500: 162, 600: 182, 700: 199, 800: 236, 900: 236, 1000: 249, 1100: 262, 1200: 274, 1300: 287, 1400: 300, 1500: 312, 1600: 325, 1700: 338, 1800: 350, 1900: 363, 2000: 376, 2100: 388, 2200: 400, 2300: 485, 2400: 584, 2500: 667, 2600: 710, 2700: 0, 2800: 0, 2900: 0, 3000: 0 },
  1600: { 300: 138, 400: 162, 500: 170, 600: 189, 700: 210, 800: 249, 900: 249, 1000: 262, 1100: 274, 1200: 287, 1300: 300, 1400: 312, 1500: 325, 1600: 338, 1700: 350, 1800: 363, 1900: 376, 2000: 388, 2100: 400, 2200: 485, 2300: 584, 2400: 667, 2500: 710, 2600: 0, 2700: 0, 2800: 0, 2900: 0, 3000: 0 }
};

// Dimensionsgrenzen für SkyVision FIXED - Zentrale Definition für die gesamte Anwendung
// Diese Werte sind als Bestellmaß definiert (nicht Rohbauöffnung)
export const FIXED_DIMENSIONS = {
  MIN_WIDTH: 300,   // 300mm Bestellmaß = 330mm Rohbauöffnung
  MAX_WIDTH: 1600,  // Basierend auf Preistabelle
  MIN_LENGTH: 300,  // 300mm Bestellmaß = 330mm Rohbauöffnung  
  MAX_LENGTH: 3000, // Basierend auf Preistabelle
  MIN_HEIGHT_DOUBLE: 210,
  MIN_HEIGHT_TRIPLE: 240,
  MAX_HEIGHT: 750, // Maximale Höhe der Unterkonstruktion
  MAX_AREA: 4,
  STEP_SIZE: 100   // 100mm Schritte statt 10mm
};

// Keine Dimensionspreisberechnung mehr nötig, da alles über die Formel läuft

/**
 * Rundet Dimensionen auf 100mm-Schritte auf
 */
const roundToStep = (value: number, step: number = 100): number => {
  return Math.ceil(value / step) * step;
};

/**
 * Sucht den Preis in der Tabelle mit Fallback-Logik
 */
const lookupPrice = (table: any, width: number, length: number): number => {
  // Runde auf 100mm-Schritte auf
  const roundedWidth = roundToStep(width);
  const roundedLength = roundToStep(length);
  
  // Direkte Suche
  if (table[roundedWidth] && table[roundedWidth][roundedLength] !== undefined) {
    const price = table[roundedWidth][roundedLength];
    return price > 0 ? price : 0; // 0-Werte bedeuten "nicht verfügbar"
  }
  
  // Fallback: Suche nächstkleinere verfügbare Größe
  const availableWidths = Object.keys(table).map(Number).sort((a, b) => a - b);
  const availableLengths = Object.keys(table[availableWidths[0]] || {}).map(Number).sort((a, b) => a - b);
  
  let fallbackWidth = availableWidths.find(w => w >= roundedWidth) || availableWidths[availableWidths.length - 1];
  let fallbackLength = availableLengths.find(l => l >= roundedLength) || availableLengths[availableLengths.length - 1];
  
  if (table[fallbackWidth] && table[fallbackWidth][fallbackLength] !== undefined) {
    const price = table[fallbackWidth][fallbackLength];
    return price > 0 ? price : 0;
  }
  
  return 0; // Kein Preis gefunden
};

/**
 * Berechnet den Preis für SkyVision FIXED basierend auf der neuen Preistabelle
 */
export const calculateFixedPrice = (
  width: number,
  length: number, 
  height: number,
  glassType: 'double' | 'triple' | null = 'double'
): number => {
  // Basis-Preis aus 2-fach Tabelle
  let basePrice = lookupPrice(FIXED_PRICE_TABLE_2FACH, width, length);
  
  if (basePrice === 0) {
    console.warn(`Kein Preis gefunden für ${width}x${length}mm`);
    return 0;
  }

  // Aufpreis für 3-fach Verglasung
  if (glassType === 'triple') {
    const surcharge = lookupPrice(FIXED_PRICE_SURCHARGE_3FACH, width, length);
    basePrice += surcharge;
  }

  // Höhenaufschlag (weiterhin 2€ pro 10mm über 210mm)
  if (height > SKYVISION_FIXED_CONFIG.baseDimensions.height) {
    const heightDiff = height - SKYVISION_FIXED_CONFIG.baseDimensions.height;
    basePrice += Math.round((heightDiff / 10) * 2);
  }

  return Math.round(basePrice);
};

/**
 * Gibt die Mindesthöhe für den angegebenen Glastyp zurück
 */
export const getMinHeightForGlassType = (glassType: 'double' | 'triple' | null): number => {
  if (glassType === 'triple' && SKYVISION_FIXED_CONFIG.glassTypes.triple) {
    return SKYVISION_FIXED_CONFIG.glassTypes.triple.minHeight;
  }
  return SKYVISION_FIXED_CONFIG.glassTypes.double.minHeight;
};

/**
 * Validiert die angegebenen Dimensionen
 */
export const validateDimensions = (
  width: number, 
  length: number, 
  height: number, 
  glassType: 'double' | 'triple' | null
): { valid: boolean; errors: string[] } => {
  const errors: string[] = [];
  const minHeight = getMinHeightForGlassType(glassType);
  
  if (width < FIXED_DIMENSIONS.MIN_WIDTH) {
    errors.push(`Mindestbreite: ${FIXED_DIMENSIONS.MIN_WIDTH}mm`);
  }
  
  if (width > FIXED_DIMENSIONS.MAX_WIDTH) {
    errors.push(`Maximale Breite: ${FIXED_DIMENSIONS.MAX_WIDTH}mm`);
  }
  
  if (length < FIXED_DIMENSIONS.MIN_LENGTH) {
    errors.push(`Mindestlänge: ${FIXED_DIMENSIONS.MIN_LENGTH}mm`);
  }
  
  if (length > FIXED_DIMENSIONS.MAX_LENGTH) {
    errors.push(`Maximale Länge: ${FIXED_DIMENSIONS.MAX_LENGTH}mm`);
  }
  
  if (height < minHeight) {
    errors.push(`Mindesthöhe für ${glassType === 'triple' ? '3-fach' : '2-fach'} Verglasung: ${minHeight}mm`);
  }
  
  if (height > FIXED_DIMENSIONS.MAX_HEIGHT) {
    errors.push(`Maximale Höhe: ${FIXED_DIMENSIONS.MAX_HEIGHT}mm`);
  }
  
  const area = (width * length) / 1000000;
  if (area > FIXED_DIMENSIONS.MAX_AREA) {
    errors.push(`Maximale Fläche: ${FIXED_DIMENSIONS.MAX_AREA}m²`);
  }

  return {
    valid: errors.length === 0,
    errors
  };
};

/**
 * Hilfsfunktionen für erweiterte Preiskonfiguration
 */

// Keine manuelle Preisanpassung mehr nötig, da alles über die Formel läuft

/**
 * Gibt eine detaillierte Preisaufschlüsselung zurück
 */
export const getPriceBreakdown = (
  width: number,
  length: number,
  height: number,
  glassType: 'double' | 'triple' | null = 'double'
): {
  basePrice: number;
  heightSurcharge: number;
  glassSurcharge: number;
  totalPrice: number;
  breakdown: string[];
} => {
  // Basis-Preis aus 2-fach Tabelle
  const basePrice = lookupPrice(FIXED_PRICE_TABLE_2FACH, width, length);
  const roundedWidth = roundToStep(width);
  const roundedLength = roundToStep(length);
  
  // Berechne Höhenaufschlag
  let heightSurcharge = 0;
  if (height > SKYVISION_FIXED_CONFIG.baseDimensions.height) {
    const heightDiff = height - SKYVISION_FIXED_CONFIG.baseDimensions.height;
    heightSurcharge = Math.round((heightDiff / 10) * 2); // 2€ pro 10mm zusätzliche Höhe
  }

  // Berechne Glasaufschlag
  let glassSurcharge = 0;
  if (glassType === 'triple') {
    glassSurcharge = lookupPrice(FIXED_PRICE_SURCHARGE_3FACH, width, length);
  }

  const totalPrice = basePrice + heightSurcharge + glassSurcharge;

  const breakdown = [
    `Grundpreis 2-fach (${roundedWidth}x${roundedLength}mm): ${basePrice}€`,
    ...(glassSurcharge > 0 ? [`3-fach Verglasung Aufpreis: +${glassSurcharge}€`] : []),
    ...(heightSurcharge > 0 ? [`Höhenaufschlag (+${height - SKYVISION_FIXED_CONFIG.baseDimensions.height}mm): +${heightSurcharge}€`] : [])
  ];

  return {
    basePrice,
    heightSurcharge,
    glassSurcharge,
    totalPrice,
    breakdown
  };
};

// Hilfsfunktionen für die Verwendung in der UI, die früher in priceConfigFixedSafe.ts waren

/**
 * Gibt die Mindestdimensionen zurück
 */
export const getFixedMinDimensions = () => {
  // Bestellmaß-Werte zurückgeben (Rohbauöffnung - 30mm)
  return {
    width: FIXED_DIMENSIONS.MIN_WIDTH,
    length: FIXED_DIMENSIONS.MIN_LENGTH,
    height: FIXED_DIMENSIONS.MIN_HEIGHT_DOUBLE
  };
};

/**
 * Gibt die Glastypen mit ihren Eigenschaften zurück
 */
export const getFixedGlassTypes = () => {
  return {
    double: {
      name: SKYVISION_FIXED_CONFIG.glassTypes.double.name,
      minHeight: SKYVISION_FIXED_CONFIG.glassTypes.double.minHeight
    },
    triple: {
      name: SKYVISION_FIXED_CONFIG.glassTypes.triple.name,
      minHeight: SKYVISION_FIXED_CONFIG.glassTypes.triple.minHeight
    }
  };
};

/**
 * Gibt die Dimensionsgrenzen zurück
 */
export const getFixedDimensions = () => {
  return FIXED_DIMENSIONS;
};

/**
 * Sichere Version von getMinHeightForGlassType
 */
export const getMinHeightForGlassTypeSafe = (glassType: 'double' | 'triple'): number => {
  return glassType === 'triple' ? FIXED_DIMENSIONS.MIN_HEIGHT_TRIPLE : FIXED_DIMENSIONS.MIN_HEIGHT_DOUBLE;
};

/**
 * Glasoptionen / Accessories Konfiguration
 * Preise werden auf Glasfläche berechnet (Bestellmaß + 260mm)
 */
export const FIXED_GLASS_OPTIONS = {
  sun_protection_glass: {
    id: 'sun_protection_glass',
    name: 'Sonnenschutzglas',
    description: 'Sonnenschutzglas für reduzierte Wärmeeinwirkung (nur bei 3-fach Verglasung)',
    pricePerSqm: 135, // €/m²
    minPrice: 135, // Minimum-Preis auch bei <1m²
    glassTypeRestriction: 'triple' as const, // Nur bei 3-fach
    calculateArea: (width: number, length: number) => {
      // Glasfläche = Bestellmaß + 260mm (130mm je Seite)
      const glassWidth = (width + 260) / 1000; // in Meter
      const glassLength = (length + 260) / 1000; // in Meter
      return glassWidth * glassLength;
    }
  },
  opal_lamination: {
    id: 'opal_lamination',
    name: 'Opallaminierung',
    description: 'Blickdichte Verglasung mit reduziertem Lichtdurchgang (tL: ca. 57%) und Gesamtenergiedurchgang (g: ca. 35%)',
    pricePerSqm: 115, // €/m²
    minPrice: 115, // Minimum-Preis auch bei <1m²
    glassTypeRestriction: 'both' as const, // Für beide Glastypen
    calculateArea: (width: number, length: number) => {
      // Glasfläche = Bestellmaß + 260mm (130mm je Seite)
      const glassWidth = (width + 260) / 1000; // in Meter
      const glassLength = (length + 260) / 1000; // in Meter
      return glassWidth * glassLength;
    }
  }
};

/**
 * Berechnet den Preis für ein Glasoption/Accessory
 */
export const calculateAccessoryPrice = (
  accessoryId: keyof typeof FIXED_GLASS_OPTIONS,
  width: number,
  length: number
): number => {
  const option = FIXED_GLASS_OPTIONS[accessoryId];
  if (!option) return 0;
  
  const area = option.calculateArea(width, length);
  const calculatedPrice = option.pricePerSqm * area;
  
  // Minimum-Preis wenn unter 1m²
  return area < 1.0 ? option.minPrice : Math.round(calculatedPrice);
};